import React, { useEffect, useState } from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import utils from '../../utils'
import Loading from '../../components/feedback/Loading'
import FetchError from '../../components/feedback/FetchError'
import { useSearchParams } from 'react-router-dom'
import blogServices from '../../services/BlogService'
import Pagination from '../../components/nav/Pagination'
import BlogList from '../../components/blog/BlogList'

const BlogHero = () => {
    return (
        <section className="relative h-[400px] flex items-center justify-center overflow-hidden bg-surface-container-low">
     
            <div className="absolute inset-0 opacity-10 pointer-events-none">
                <div
                    className="absolute inset-0 opacity-5"
                    style={{
                        backgroundImage: 'linear-gradient(#005baf 1px, transparent 1px), linear-gradient(90deg, #005baf 1px, transparent 1px)',
                        backgroundSize: '100px 100px'
                    }}
                ></div>
            </div>

            <div className="relative z-10 text-center px-8">
                <div className="inline-block px-4 py-1.5 mb-6 rounded-full bg-primary/5 border border-primary/10">
                    <span className="text-xs font-bold uppercase tracking-[0.2em] text-primary">
                        Knowledge Hub
                    </span>
                </div>

                <h1 className="text-3xl md:text-5xl font-headline font-black tracking-tight text-on-surface mb-6 leading-[1.1]">
                    Construction <br className="hidden md:block" /> Insights & Tips
                </h1>

                <p className="text-lg md:text-xl text-on-surface-variant max-w-2xl mx-auto leading-relaxed">
                    Expert guidance on structural engineering, modern architectural trends,
                    and project management for the contemporary developer.
                </p>
            </div>

            <div className="absolute -top-24 -right-24 w-96 h-36 bg-primary/5 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-24 -left-24 w-96 h-36 bg-primary/5 rounded-full blur-3xl"></div>
        </section>
    );
};

function BlogListPage() {
    const [searchParam, setSearchParams] = useSearchParams()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState()
    const [blogs, setBlogs] = useState()

    useEffect(() => {
        const params = searchParam.toString()
        setLoading(true)
        blogServices.getBlogs(params ? `?${params}` : '').then(
            res => {
                setBlogs(res.data)
                setLoading(false)
            },
            err => {
                console.log(err)
                setError(err)
                setLoading(false)
            }
        )
    }, [searchParam])
    useEffect(() => { }, [loading])
    useEffect(() => { }, [error])
    useEffect(() => {
        if (blogs) {
            const top = document.getElementById("nav-top")
            top.scrollIntoView({ behavior: "smooth" })
        }
    }, [blogs])

    function changePageParam(page) {
        if (page) {
            setSearchParams((params) => {
                params.set("page", page)
                return params
            })
        } else {
            setSearchParams((params) => {
                params.delete("page")
                return params
            })
        }
    }
    return (
        <HelmetProvider>
            <Helmet>
                <title>Blog - {utils.siteName}</title>
            </Helmet>
            <BlogHero />
            <div className='container mx-auto px-3 mb-16'>
                <div>
                    {loading ? (<Loading />) : (
                        <div>
                            {error ? (<FetchError error={error} />) : (
                                <div>
                                    <BlogList blogs={blogs} />
                                    {((blogs?.next !== null) || (blogs?.previous !== null)) && (
                                        <Pagination
                                            next={blogs?.next}
                                            previous={blogs?.previous}
                                            changePageParam={changePageParam}
                                            isAdmin={false}
                                        />
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </HelmetProvider>
    )
}

export default BlogListPage